import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SegmentedToggleOption } from '../../ui/segmented-toggle/segmented-toggle.component';

export interface TabTableConfig {
  label: string;
  data: any[];
  columns: string[];
  columnHeaders: Record<string, string>;
  emptyMessage?: string;
  icon?: string;
  iconColor?: string;
}

@Component({
  selector: 'app-expandable-tab-table',
  templateUrl: './expandable-tab-table.component.html',
  styleUrls: ['./expandable-tab-table.component.scss']
})
export class ExpandableTabTableComponent implements OnInit, OnChanges {
  @Input() tabs: TabTableConfig[] = [];
  @Input() loading: boolean = false;

  selectedTabIndex: number = 0;
  toggleOptions: SegmentedToggleOption[] = [];

  ngOnInit(): void {
    this.updateToggleOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabs']) {
      this.updateToggleOptions();
    }
  }

  updateToggleOptions(): void {
    this.toggleOptions = this.tabs.map((tab, index) => ({
      label: tab.label,
      value: index,
      icon: tab.icon,
      iconColor: tab.iconColor
    }));
    if (this.toggleOptions.length > 0 && this.selectedTabIndex >= this.tabs.length) {
      this.selectedTabIndex = 0;
    }
  }

  onTabChange(selectedIndex: number): void {
    this.selectedTabIndex = selectedIndex;
  }

  getSelectedTab(): TabTableConfig | null {
    return this.tabs[this.selectedTabIndex] || null;
  }

  getCellValue(row: any, column: string): any {
    return row[column];
  }

  getColumnHeader(columnHeaders: Record<string, string>, column: string): string {
    return columnHeaders[column] || column;
  }

  getStatusBadgeText(tabLabel: string): string {
    return tabLabel === 'Eligible' ? 'Eligible' : 'Ineligible';
  }

  getStatusBadgeClass(tabLabel: string): string {
    return tabLabel === 'Eligible' ? 'eligible' : 'ineligible';
  }

  getDisplayValue(row: any, tab: TabTableConfig): string {
    const pointsBreakdown = row['pointsBreakdown'];
    const comments = row['comments'];
    return pointsBreakdown || comments || '';
  }
}
